import { UsageLimitDto } from '@_dto/global/vehicleInfoDto/usageLimit/usage-limit.dto';
import { ContractDuration } from '@_models/vehicleInfo/usageLimit/contract-duration.model';
import { DailyMission } from '@_models/vehicleInfo/usageLimit/daily-mission.model';
import { TotalDeliveryEnergy } from '@_models/vehicleInfo/usageLimit/total-delivery-energy.model';

export class UsageLimit {
	dailyMission: DailyMission;
	totalDeliveredEnergy: TotalDeliveryEnergy;
	contractDuration: ContractDuration;
	intensiveMileageLimit: number;

	constructor(usageLimitDto?: UsageLimitDto) {
		if (usageLimitDto) {
			this.dailyMission = new DailyMission(usageLimitDto.dailyMissionResult);
			this.contractDuration = new ContractDuration(usageLimitDto.contractDurationResult);
			this.totalDeliveredEnergy = new TotalDeliveryEnergy(usageLimitDto.totalDeliveryEnergyResult);
		}
	}
}
